module.exports = __webpack_public_path__ + "img/awronore-mobile-mockup.cd87cb98.jpg";